<template>
 <div class="root">
        <header>About Us</header>
        <p>
            Welcome to Haba, Haba is a place for your creativity and expression. It’s also a global community of people looking for a fun, welcoming experience.
        </p>
    </div>
</template>  

<script>
export default {
  name: "about",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root{
    text-align: left;
    margin: 10px;
}
header{
     
    padding: 10px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
    font-weight: 900;
}
div {
    font-size: 25px;
    font-weight: 900;
}
b{
    font-size: 20px;
    font-weight: 900;
}

p{
    font-size: 16px;
    font-weight: 500;
}
table {
    border-collapse: collapse;
}

th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}
td ,li{
    font-size: 16px;
}
a{
    color: blue;
}</style>
